/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum KycCertificationChoiceMode {
    SELF_ATTESTED = 'SELF_ATTESTED',
    CERTIFIER = 'CERTIFIER',
}
